// @flow

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'WebLayout':
      return import('./components/WebLayout');
    case 'SubscribePopup':
      return import('./components/SubscribePopup');
    case 'MenuHandler':
      return import('./components/MenuHandler');
    case 'LangAndCurrencyHandler':
      return import('./components/LangAndCurrencyHandler');
    case 'FaqList':
      return import('./components/faq/FaqList');
    case 'HpBannersSlider':
      return import('./components/HpBannersSlider');
      case 'AwardsSlider':
      return import('./components/AwardsSlider');
    case 'RadioSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'CheckboxSelect':
      return import('fg-frontend/src/components/CheckboxSelect');
    case 'SimpleCollapse':
      return import('./components/SimpleCollapse');
    case 'GreedyMenu':
      return import('fg-frontend/components/GreedyMenu');
    case 'Typeahead':
      return import('fg-frontend/components/Typeahead');
    case 'SelectDesign':
      return import('./components/SelectDesign');
    case 'ListToggle':
      return import('fg-frontend/components/ListToggle');
    case 'PasswordToggle':
      return import('fg-frontend/components/PasswordToggle');
    case 'SocialShare':
      return import('fg-frontend/components/SocialShare');
    // case 'AnchorsList':
    //   return import('fg-frontend/src/components/AnchorsList');
    case 'Slider':
      return import('fg-frontend/components/Slider');
    case 'RadioSelectTab':
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'NumberInput':
      return import('fg-frontend/components/NumberInput');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'Tooltip':
      return import('./components/Tooltip');
    case 'GtmHandler':
      return import('./components/GtmHandler');
    case 'TriggerInViewport':
      return import('./components/TriggerInViewport');
    case 'ShareUrl':
      return import('fg-frontend/src/components/ShareUrl');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'RedirectToUrl':
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'Form':
      return import('./components/Form');
    case 'LazyImage':
      return import('./components/LazyImage');
    case 'Webslider':
      return import('fg-frontend/src/components/Webslider');
    case 'Countdown':
      return import('./components/Countdown');
    case 'Toggler':
      return import('./components/Toggler');
    case 'PrintPage':
      return import('fg-frontend/src/components/PrintPage');
    case 'PrintPdf':
      return import('fg-frontend/src/components/PrintPdf');
    case 'FileInput':
      return import('fg-frontend/src/components/FileInput');
    case 'FGUpload':
      return import('./components/FGUpload');
    case 'ShowMorePhotos':
      return import('./components/ShowMorePhotos');
    case 'RangeSlider':
      return import('fg-frontend/src/components/RangeSlider');
    case 'RangeDatepicker':
      return import('fg-frontend/components/RangeDatepicker');
    case 'FavouriteCategories':
      return import('./components/FavouriteCategories');
    case 'HeroVideo':
      return import('./components/HeroVideo');
    case 'VideoPopup':
      return import('./components/VideoPopup');
    case 'ContentVideo':
      return import('./components/ContentVideo');
    case 'FeathersMove':
      return import('./components/FeathersMove');
    case 'AnimateInViewport':
      return import('./components/AnimateInViewport');
    case 'AnchorSlider':
      return import('./components/AnchorSlider');
    case 'ImageParallax':
      return import('./components/ImageParallax');
    case 'AlertBox': // COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
      return import('fg-frontend/src/components/AlertBox');
    case 'SectionList':
      return import('./components/SectionList');
    case 'GoogleMap':
      return import('./components/GoogleMap');
    case 'GoogleMapDetail':
      return import('./components/GoogleMapDetail');
    case 'PageViewCount': // COMMON: Komponenta pro pocitani pristupu na stranku a odeslani pred DL push
      return import('./components/PageViewCount');
    case 'FilterFormReset': // COMMON: Komponenta pro vyresetovaní filtracniho formulare
      return import('./components/FilterFormReset');
    case 'ColorDescriptionSlider':
      return import('./components/ColorDescriptionSlider');
    case 'GiftWrap':
      return import('./components/GiftWrap');
    case 'DesignersSlider':
      return import('./components/DesignersSlider');
    case 'ConfiguratorGallery':
      return import('./components/ConfiguratorGallery');
      case 'FilterMap':
      return import('./components/FilterMap');
    case 'FulltextAnchors':
      return import('./components/FulltextAnchors');
    case 'GoogleRecaptcha': // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'PreventDoubleClickHandler': // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
    case 'AnchorsList':
      return import('./components/AnchorsList');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js